<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 redeem-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/logo-white.png'"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                                <div class="col-md-6">
                                    <h1 class="title">Gift Card</h1>
                                </div>

                            </div>
                        </div>
                        <div class="card card-title">
                            <h3>Claim Your Gift</h3>

                        </div>
                        <div class="card-body">
                            <form id="frm_company_email" action="" enctype="multipart/form-data" method="POST">
                                <table width="100%" class="table">
                                    <tbody>
                                        
                                        <input type="hidden" name="_token" v-bind:value="csrf">
                                        <tr v-if="wallet_exist == 0">
                                            <td style="vertical-align: middle;"><strong>Email:</strong></td>
                                            <td>
                                                <input class="form-control" type="email" name="company_email" id="company_email" value="" placeholder="Your Registered Email" required="" v-bind:value="company_email" />
                                            </td>
                                        </tr>
                                        <tr v-if="wallet_exist == 0" style="text-align: center;">
                                            <td colspan="2">
                                                <div style="width: 100%;overflow: hidden;margin: 0 auto 5px;max-width: 320px;position: relative;clear: both;">
                                                    <vue-recaptcha sitekey="6Lf75zEUAAAAAI3SawkXu1GCgLeDaZbfvudKzDMX" :loadRecaptchaScript="true"></vue-recaptcha>
                                                </div>
                                                <button class="btn btn-redeem"> Verify</button>
                                            </td>
                                        </tr>
                                        <tr v-if="not_valid == 1 && recaptcha_is_valid != ''">
                                            <td colspan="2">
                                                <div class="alert alert-warning text-center" role="alert" style="margin: 0;">
                                                    Your email is invalid 
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="not_valid == 1 && recaptcha_is_valid == ''">
                                            <td colspan="2" style="border: 0;">
                                                <div class="alert alert-warning text-center" role="alert" style="margin: 0;">
                                                    reCAPTCHA is required
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </form>

                                <table id="ggc-plus-container" width="100%" class="table" v-if="wallet_exist == 1">          
                                    <tbody>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: top;"><strong>Email:</strong></td>
                                            <td style="vertical-align: top;">
                                                <label class="hidden-md-up">Email:</label>
                                                <b>{{ this.company_email }}</b>
                                                <p style="margin: 0;"><a href="javascript:;" @click="changeEmail()">Reset</a></p>
                                                <input type="hidden" name="recipient_email" id="recipient_email" v-bind:value="company_email" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Wallet Balance:</strong></td>
                                            <td>
                                                <label class="hidden-md-up">Wallet Balance:</label>
                                                {{ this.wallet_balance | currency('&#8369; ') }} <a @click="topUpWallet(company_email)" href="javascript:;" class="btn btn-topup">Topup Gifted Wallet</a>
                                            </td>
                                        </tr>
                                        <tr v-if="pending_credits > 0">
                                            <td colspan="2">
                                                <p style="padding: 0; margin: 0;">You have one ({{ this.pending_credits }}) gift card pending redemption verification. We will email you within 1-2 working days once the balance is credited to your account so you can start selecting brands. Thank you!</p>
                                            </td>
                                        <tr>
                                        <tr v-if="redemption_credits > 0">
                                            <td colspan="2">
                                                <p style="padding: 0; margin: 0;">You have one ({{ this.redemption_credits }}) gift card available for redemption.</p>
                                            </td>
                                        <tr>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Product:</strong></td>
                                            <td>
                                                <label class="hidden-md-up">Product:</label>
                                                <select @change="productSelect" style="width: 100%; max-width: 240px; margin: 0;" name="product_id" id="product_id" class="form-control" required="">
                                                    <option value="" selected="selected" data-denomination="" data-url="">-- Select --</option>

                                                    <option v-for="product in product_options" :key="product.product_id" :value="product.product_id" :data-denominations="product.product_denominations"  :data-url="product.product_url">{{ product.product_name }}</option>

                                                </select>
                                                <div id='product-link' style='margin-top: 5px;'></div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="hidden-sm-down" style="vertical-align: middle;"><strong>Denomination:</strong></td>
                                            <td>
                                                <label class="hidden-md-up">Denomination:</label>
                                                <select @change="denominationSelect" style="width: 100%; max-width: 240px; margin: 0;" name="product_denomination" id="product_denomination" class="form-control" required="">
                                                    <option value="" selected="selected">-- No Product Selected  --</option>
                                                    
                                                </select>
                                            </td>
                                        </tr>
                                        

                                        <tr v-if="wallet_balance > 0">
                                            <td colspan="2">
                                                <button id="redeemBtn" class="btn btn-redeem" @click="redeem()"> <i class="fa fa-gift"></i> Claim</button>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                                <table id="ggc-plus-container" width="100%" class="table" v-if="wallet_exist == 1">          
                                    <tbody>
                                        <tr>
                                            <td colspan="3"><h4 style="text-align: center; margin-top: 15px;">Your Recent Redemption below</h4></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 40%;"><b>Order #</b></td>
                                            <td style="width: 40%;"><b>Product</b></td>
                                            <td style="width: 20%;"></td>
                                        </tr>

                                        <template v-for="order in my_orders">
                                        <tr>
                                            <td>
                                                <p style="margin: 0;"><b>{{ order.order_number }}</b></p>
                                                <p style="margin: 0;"><i>{{ order.ordered_on }}</i></p>
                                            </td>
                                            <td>{{ order.product_name }}</td>
                                            <td>
                                                <a  v-if="order.voucher_id > 0" href="javascript:;" @click="resend(order.id)" class="btn btn-danger btn-sm">Resend</a>
                                                <span v-if="order.voucher_id <= 0">No Voucher Yet</span>
                                            </td>
                                        </tr>
                                        </template>

                                    </tbody>
                                </table>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .swal2-title{
        display: block !important;
    }
    .swal2-select{
        margin: 0 auto;
        width: 100%;
        max-width: 265px;
        border-radius: 5px;
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        background: url('/img/dropdown-arrow.png') no-repeat right center;
        background-size: contain;
    }
    .swal2-select:focus{
        border: 1px solid #DE3C4C;
        outline: none;
    }
    .swal2-validation-message{
        background-color: transparent;
    }
    .hidden-sm-down{
        display: block;
    }
    .hidden-md-up{
        display: none;
    }

    .swal2-radio{
        display: block !important;
        margin:  0 auto !important;
    }
    .swal2-radio label{
        margin: 5px;
        padding: 0;
        display: inline-block;
        width: 33.33%;
    }
    .swal2-radio label input[type=radio]{
        display: none;
    }
    .swal2-radio label input[type=radio]  +  .swal2-label{
        border: 1px solid #ccc;
        width: 100%;
        margin: 1%;
        padding: 10px;
        cursor: pointer;
        display: block;
    }
    .swal2-radio label input[type=radio]:checked  +  .swal2-label{
        background-color: #d0211c;
        color: #fff;
    }
    .swal2-html-container #enterAmount{
        border: 1px solid #ccc;
        width: 100%;
        display: block;
        max-width: 200px;
        margin: 0 auto;
        padding: 10px 15px;
        text-decoration: none;
        color: rgb(222, 60, 76);
    }
    .swal2-html-container #enterAmount:hover{
        background-color: #d0211c;
        color: #fff;
    }

    .form-control.error{
        border: 1px solid red;
    }
    #resendOTP{
        background-color: rgb(222, 60, 76);
        border-color: rgb(222, 60, 76);
    }

    @media only screen and (max-width: 767px) {
        .hidden-md-up{
            display: block;
        }
        .hidden-sm-down{
            display: none;
        }
        .swal2-title{
            font-size: 24px;
            line-height: 17px;
        }
    }
</style>
<style scoped>
    .redeem-voucher{
        max-width: 500px;
        margin: 0 auto;
    }
    .redeem-voucher .card-header{
        background-color: #DE3C4C;
    }
    .redeem-voucher .card-header .title{
        font-size: 30px;
        color: #fff;
        text-align: right;
        margin: 0 auto;
        padding: 8px 0;

    }
    .redeem-voucher .card-title{
        border: 0;
        margin: 0;
    }
    .redeem-voucher .card-title h3{
        text-align: center;
        padding: 15px;
        background-color: #eee;
        margin: 0;
    }
    .redeem-voucher table{
        margin: 0;
    }
    .redeem-voucher table tr:first-child td{
        border-top: 0;
    }
    .redeem-voucher button.btn-redeem{
        width: 100%;
        background-color: #DE3C4C;
        color: #fff;
        font-size: 20px;
        outline: 0;
        border: 0;
    }
    .redeem-voucher button.btn-redeem:hover, .redeem-voucher button.btn-redeem:focus{
        outline: 0;
        border: 0;
    }
    .redeem-voucher .btn-topup{
        background-color: #de3c4c;
        color: #fff;
    }


</style>
<script>
    import VueRecaptcha from 'vue-recaptcha'

    export default {
        components: { VueRecaptcha },
        props: ['ggc', 'orders'],
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            company_email: "",
            firstname: "",
            lastname: "",
            not_valid: "",
            wallet_exist: "",
            wallet_transaction_count: "",
            wallet_cash_in: "",
            wallet_cash_out: "",
            wallet_balance: "",
            service_fee_credits_balance: "",
            product_options: "",
            products_available: "",
            products_denominations: "",
            ggc_plus_otp_session: "",
            recaptcha_is_valid: "",
            pending_credits: "",
            redemption_credits: "",
            my_orders: "",
        }), 
        mounted() {
    
            const ggc = JSON.parse(this.ggc)
            this.company_email = ggc.company_email;
            this.firstname = ggc.firstname;
            this.lastname = ggc.lastname;
            this.not_valid = ggc.not_valid;
            this.wallet_exist = ggc.wallet_exist;
            this.wallet_transaction_count = ggc.wallet_transaction_count;
            this.wallet_cash_in = ggc.wallet_cash_in;
            this.wallet_cash_out = ggc.wallet_cash_out;
            this.wallet_balance = ggc.wallet_balance;
            this.service_fee_credits_balance = ggc.service_fee_credits_balance;
            this.product_options = ggc.product_options;
            this.products_available = ggc.products_available;
            this.ggc_plus_otp_session = ggc.ggc_plus_otp_session;
            this.recaptcha_is_valid = ggc.recaptcha_is_valid;
            this.pending_credits = ggc.pending_credits;
            this.redemption_credits = ggc.redemption_credits;

            const orders = JSON.parse(this.orders)
            this.my_orders = orders;

            if(this.wallet_exist == 1){
                if(this.ggc_plus_otp_session == 1){

                    $('#ggc-plus-container').removeAttr("style");

                }else{
                    $('#ggc-plus-container').hide();

                    Swal.fire({
                        //title: 'Verify Your Redemption',
                        showCancelButton: true,
                        confirmButtonText: 'Submit',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        showCancelButton: false,
                        allowEscapeKey: false,
                        background: '#fff',
                        backdrop: 'rgb(198, 227, 222)',
                        //input: 'text',
                        html: '<h3>Verify Your Account</h3><p>Click on Send PIN to send a One Time PIN to your email address to validate your account</p><div class="input-group mb-0">'+
                              '<div class="input-group-prepend">'+
                              '  <button id="resendOTP" data-email="'+this.company_email+'" data-source="GGC Plus Login" class="btn btn-secondary" type="button" style="width: 130px; border-color: rgb(222, 60, 76); background-color: rgb(222, 60, 76);"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                              '</div>'+
                              '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                              '</div>'+
                              '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                              '<div id="otp-message"></div>',
                        footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                        preConfirm: (isConfirm) => {

                            if (!isConfirm) return;

                            var otp = document.getElementById('swal-input2-otp').value;
                            if (otp != '') {
                                
                                return $.ajax({
                                    type: "POST",
                                    url: "/api/validate_otp_session1",
                                    data: { 'email': this.company_email, 'otp': otp },
                                    cache: false,
                                })
                                .then(response => {

                                    //console.log(response);
                                    const is_validate_otp = JSON.parse(response);
                                    if(is_validate_otp.response.class == "success"){

                                        $('#ggc-plus-container').show();

                                    }else{

                                        Swal.showValidationMessage(
                                              `OTP is invalid. Please check your email.`
                                            );
                                        $('#swal-input2-otp').focus();

                                    }
                                })
                                .catch(error => {
                                    Swal.showValidationMessage(
                                      `Request OTP failed. Pls try again later.`
                                    )
                                })
               
                            }else{
                                Swal.showValidationMessage(
                                      `OTP is required. Please check your email.`
                                    );
                                $('#swal-input2-otp').focus();
                            }

                        },
                        allowOutsideClick: false,
                    });
                }
            }
        },
        methods: {
            merchant_sevice_fee_credits_info: function () {
                Swal.fire({
                  //icon: 'info',
                  title: 'Merchant Fee Credits',
                  html: 'Some brands have a Merchant Fee or service fee charged on top of its value.  A Merchant Fee Credit means that your gift giver has paid for any Merchant Fees associated with your gift card.',
                  showConfirmButton: true,
                  confirmButtonColor: '#DE3C4C',
                  confirmButtonText: 'Close',
                });
            },
            redeem: function () {
                var productID = $('#product_id').val();
                var denomination = $('#product_denomination').val();
                var email = this.company_email;

                if(denomination > 0 && productID > 0){

                    /*
                    Swal.fire({
                        //title: 'Verify Your Redemption',
                        showCancelButton: true,
                        confirmButtonText: 'Submit',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        background: '#fff',
                        backdrop: 'rgb(198, 227, 222)',
                        //input: 'text',
                        html: '<h3>Verify Your Redemption</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                              '<div class="input-group-prepend">'+
                              '  <button id="resendOTP" data-email="'+email+'" data-source="GGC Plus Redemption" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                              '</div>'+
                              '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                              '</div>'+
                              '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                              '<div id="otp-message"></div>',
                        footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                        preConfirm: (isConfirm) => {

                            if (!isConfirm) return;

                            var otp = document.getElementById('swal-input2-otp').value;
                            if (otp != '') {
                                
                                return $.ajax({
                                    type: "POST",
                                    url: "/api/validate_otp",
                                    data: { 'email': email, 'otp': otp },
                                    cache: false,
                                })
                                .then(response => {

                                    //console.log(response);
                                    const is_validate_otp = JSON.parse(response);
                                    if(is_validate_otp.response.class == "success"){

                    */
                                        Swal.fire({
                                            title: 'Are you sure?',
                                            showCancelButton: true,
                                            confirmButtonText: 'Claim',
                                            confirmButtonColor: '#DE3C4C',
                                            showLoaderOnConfirm: true,
                                            background: '#fff',
                                            backdrop: 'rgb(198, 227, 222)',
                                            preConfirm: (isConfirm) => {

                                                if (!isConfirm) return;

                                                return $.ajax({
                                                    type: "POST",
                                                    url: "/api/ggc_plus_generic_with_fees1",
                                                    data: { 'email': email, 'productID': productID, 'denomination': denomination },
                                                    cache: false,
                                                })
                                                .then(response => {
                                                    console.log(response);
                                                    return response
                                                })
                                                .catch(error => {
                                                    Swal.showValidationMessage(
                                                      `Request failed! Please contact support.`
                                                    )
                                                })
                               
                                            },
                                            allowOutsideClick: () => !Swal.isLoading()
                                        }).then((result) => {
                                            console.log(result);
                                            
                                            const new_result = JSON.parse(result.value);
                                            console.log(new_result);
                                            if (new_result) {
                                                Swal.fire({
                                                  icon: new_result.response.class,
                                                  title: new_result.response.message,
                                                  confirmButtonColor: '#DE3C4C',
                                                  confirmButtonText: 'Close'
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        location.reload();
                                                    }
                                                });
                                            }
                                        });

                    /* 
                                    }else{

                                        Swal.showValidationMessage(
                                              `OTP is invalid. Please check your email.`
                                            );
                                        $('#swal-input2-otp').focus();

                                    }
                                })
                                .catch(error => {
                                    Swal.showValidationMessage(
                                      `Request OTP failed. Pls try again later.`
                                    )
                                })
               
                            }else{
                                Swal.showValidationMessage(
                                      `OTP is required. Please check your email.`
                                    );
                                $('#swal-input2-otp').focus();
                            }

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    });
                    */
                }else{
                    Swal.fire({
                      icon: 'error',
                      title: 'No Product Selected or Invalid Denomination',
                      showConfirmButton: false,
                      timer: 2000
                    })
                }
            },
            resend: function (order_id) {
                //alert(order_id);

                Swal.fire({
                    title: 'Resend this Voucher?',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonColor: '#DE3C4C',
                    showLoaderOnConfirm: true,
                    background: '#fff',
                    backdrop: 'rgb(198, 227, 222)',
                    preConfirm: (isConfirm) => {

                        if (!isConfirm) return;

                        return $.ajax({
                            type: "GET",
                            url: "/api/sendVoucher1/"+order_id,
                            //data: { 'id': order_id },
                            cache: false,
                        })
                        .then(response => {
                            console.log(response);
                            //return response

                            if (response == 1) {
                                Swal.fire({
                                  icon:"success",
                                  title: "Your voucher successfully sent!",
                                  confirmButtonColor: '#DE3C4C',
                                  confirmButtonText: 'Close'
                                });
                            }else{
                                Swal.showValidationMessage(
                                  `Request failed! Please contact support.`
                                )
                            }

                        })
                        .catch(error => {
                            Swal.showValidationMessage(
                              `Request failed! Please contact support.`
                            )
                        })
       
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    console.log(result);
                    
                    if (result == 1) {
                        Swal.fire({
                          icon:"success",
                          title: "Your voucher successfully sent!",
                          confirmButtonColor: '#DE3C4C',
                          confirmButtonText: 'Close'
                        });
                    }else{
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    }
                });

            },
            changeEmail: function () {

                /*
                Swal.fire({
                    title: 'Are you sure to change Email?',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    showLoaderOnConfirm: true,
                    background: '#fff',
                    backdrop: 'rgb(209 73 85 / .9)',
                    preConfirm: (isConfirm) => {
                        if (!isConfirm) return;

                        $('<input type="hidden" name="company_email" id="company_email" value="" />').appendTo('#frm_company_email');
                        $('#frm_company_email').submit();
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                })*/
                $('<input type="hidden" name="company_email" id="company_email" value="" />').appendTo('#frm_company_email');
                $('#frm_company_email').submit();
            },
            productSelect:function(e){
                if (e.target.options.selectedIndex > -1) {
                    const theTarget = e.target.options[e.target.options.selectedIndex].dataset;

                    if(theTarget.url){
                        $( "#product-link" ).html('<a target="_blank" href="https://gifted.ph/'+theTarget.url+'">View Product</a>');
                    }else{
                        $( "#product-link" ).html('');
                    }

                    this.products_denominations = theTarget.denominations;
                    if(this.products_denominations){
                        this.products_denominations = this.products_denominations.split(',');

                        let options = '';
                        this.products_denominations.map((deno) =>{
                            if(deno){
                                options += `<option value="${deno}">${deno}</option>`;
                            }
                        });
                        $('#product_denomination').html(options);
                        console.log(this.products_denominations);
                    }else{
                        $('#product_denomination').html('');
                    }

                
                    /*
                    Swal.fire({
                      icon: 'warning',
                      title: 'Please wait!',
                      html: 'Your voucher is processing...',
                      showConfirmButton: false,
                      timer: 2000,
                      timerProgressBar: true,
                    })
                    */

                    var productID = event.target.value;
                    var denomination = this.products_denominations[0];
                    //alert(denomination);

                    $.ajax({
                        type: "POST",
                        url: "/api/product_merchant_fee",
                        data: {'email': this.company_email, 'productID': productID, 'denomination': denomination},
                        cache: false,
                    })
                    .then(response => {
                        console.log(response);
                        //return response;
                        const result = JSON.parse(response);
                        if(result.response.data > 0){
                            Swal.fire({
                              icon: result.response.class,
                              title: result.response.message,
                              html: '',
                              confirmButtonText: 'Got it!',
                              confirmButtonColor: '#DE3C4C',
                              showLoaderOnConfirm: true,
                            });
                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });
                     
                }
            },
            denominationSelect:function(e){
                var productID = $('#product_id').val();

                if (productID) {

                    var denomination = event.target.value;
                    //alert(denomination);

                    $.ajax({
                        type: "POST",
                        url: "/api/product_merchant_fee",
                        data: {'email': this.company_email, 'productID': productID, 'denomination': denomination},
                        cache: false,
                    })
                    .then(response => {
                        console.log(response);
                        //return response;
                        const result = JSON.parse(response);
                        if(result.response.data > 0){
                            Swal.fire({
                              icon: result.response.class,
                              title: result.response.message,
                              html: '',
                              confirmButtonText: 'Got it!',
                              confirmButtonColor: '#DE3C4C',
                              showLoaderOnConfirm: true,
                            });
                        }
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support.`
                        )
                    });
                }
            },
            topUpWallet:function(email){
                Swal.fire({
                        //title: 'Verify Your Top-up',
                        showCancelButton: true,
                        confirmButtonText: 'Submit',
                        confirmButtonColor: '#DE3C4C',
                        showLoaderOnConfirm: true,
                        background: '#fff',
                        backdrop: 'rgb(198, 227, 222)',
                        //input: 'text',
                        html: '<h3>Verify Your Top-up</h3><p>Click on Send PIN to send a One Time PIN to your email address to confirm your redemption</p><div class="input-group mb-0">'+
                              '<div class="input-group-prepend">'+
                              '  <button id="resendOTP" data-email="'+email+'" data-source="GGC Plus Wallet Topup" class="btn btn-secondary" type="button" style="width: 130px;"><span id="btn-text">Send PIN</span> <span id="timer"></span></button>'+
                              '</div>'+
                              '<input type="text" id="swal-input2-otp" class="form-control swal2-input" placeholder="Enter PIN" style="margin: 0;">'+
                              '</div>'+
                              '<p style="margin-top: 15px;">Click <a onclick="$(\'#resendOTP\').trigger(\'click\')" href="javascript:;">here</a> to resend the PIN to your email</p>'+
                              '<div id="otp-message"></div>',
                        footer: '<p style="text-align: center;">For any inquiries, please email us at admin@gifted.ph</p>',
                        preConfirm: (isConfirm) => {

                            if (!isConfirm) return;

                            var otp = document.getElementById('swal-input2-otp').value;
                            if (otp != '') {
                                
                                return $.ajax({
                                    type: "POST",
                                    url: "/api/validate_otp1",
                                    data: { 'email': email, 'otp': otp },
                                    cache: false,
                                })
                                .then(response => {

                                    //console.log(response);
                                    const is_validate_otp = JSON.parse(response);
                                    if(is_validate_otp.response.class == "success"){

                                        var topUpAmount;
                                        var topUpVia;

                                        var amountOptions = new Promise(function(resolve) {
                                            resolve({
                                              //'1': '&#8369;1',
                                              '50': '&#8369;50',
                                              '100': '&#8369;100',
                                              '300': '&#8369;300',
                                              '500': '&#8369;500',
                                              '1000': '&#8369;1,000',
                                              '2000': '&#8369;2,000',
                                              '5000': '&#8369;5,000',
                                              '10000': '&#8369;10,000',
                                            });
                                        });

                                        Swal.fire({
                                            title: 'How much?',
                                            input: 'radio',
                                            showCancelButton: true,
                                            confirmButtonText: 'Top Up',
                                            confirmButtonColor: '#DE3C4C',
                                            showLoaderOnConfirm: true,
                                            background: '#fff',
                                            backdrop: 'rgb(198, 227, 222)',
                                            inputOptions: amountOptions,
                                            html : '<a href="javascript:;" id="enterAmount">Enter Amount</a>',
                                            onOpen: function(ele) {
                                                $('.swal2-html-container').insertAfter('.swal2-radio');
                                                
                                                $(document).on('click', '#enterAmount', function(e) {

                                                    Swal.fire({
                                                        title: 'Enter amount',
                                                        input: 'number',
                                                        inputAttributes: {
                                                            autocapitalize: 'off'
                                                        },
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Top Up',
                                                        confirmButtonColor: '#DE3C4C',
                                                        showLoaderOnConfirm: true,
                                                        background: '#fff',
                                                        backdrop: 'rgb(198, 227, 222)',
                                                        preConfirm: (value) => {
                                                            topUpAmount= value;
                                                            if(value <= 0){
                                                                Swal.showValidationMessage(
                                                                      `Amount is required.`
                                                                    )
                                                            }else{

                                                                Swal.fire({
                                                                    title: 'Topup via Bank Transfer',
                                                                    confirmButtonColor: '#DE3C4C',
                                                                    showLoaderOnConfirm: true,
                                                                    showCancelButton: true,
                                                                    background: '#fff',
                                                                    backdrop: 'rgb(198, 227, 222)',
                                                                    html:
                                                                    '<p>This is a form to submit your deposit slip for topup payment.</p>' +
                                                                    '<div class="form-row">' +
                                                                        '<div class="form-group col-md-12">' +
                                                                            '<label for="">Please choose the bank account you will be depositing to: </label>' +
                                                                            '<select name="gifted_bank" id="gifted_bank" class="form-control" required>' +
                                                                                '<option value="">Select Gifted Bank Account</option>' +
                                                                                '<option value="BDO Account : 006938009120">BDO account : 006938009120</option>' +
                                                                                '<option value="BPI Account: 3911-0043-12">BPI Account: 3911-0043-12</option>' +
                                                                                '<option value="Unionbank Account: 00-192-000113-2">Unionbank Account: 00-192-000113-2</option>' +
                                                                            '</select>' +
                                                                        '</div>' +
                                                                    '</div>' +
                                                                    '<p>Our Bank Account Name is "E-link Business Innovation Corp"<br />After you deposit, please provide details about your deposit slip so we can verify your topup:</p>' +
                                                                    '<div class="form-row">' +
                                                                        '<div class="form-group col-md-6">' +
                                                                            '<label for="">Your Bank Name</label>' +
                                                                            '<input type="text" class="form-control" id="bank_name" name="bank_name" placeholder="Bank Name" required/>' +
                                                                        '</div>' +
                                                                        '<div class="form-group col-md-6">' +
                                                                            '<label for="">Account Name</label>' +
                                                                            '<input type="text" class="form-control" id="account_name" name="account_name" placeholder="Account Name" required />' +
                                                                        '</div>' +
                                                                    '</div>' +
                                                                    '<div class="form-row">' +
                                                                        '<div class="form-group col-md-6">' +
                                                                            '<label for="">Your Account Number</label>' +
                                                                            '<input type="text" class="form-control" id="account_number" name="account_number" placeholder="Account Number" required />' +
                                                                        '</div>' +
                                                                        '<div class="form-group col-md-6">' +
                                                                            '<label for="">Deposit Slip (2MB)</label>' +
                                                                            '<input type="file" class="form-control" id="deposit_slip" name="deposit_slip" accept="image/*" required  />' +
                                                                        '</div>' +
                                                                        '<div class="form-group col-md-6" style="display: none;">' +
                                                                            '<label for="">Amount</label>' +
                                                                            '<input type="text" class="form-control" id="amount" name="amount" placeholder="Amount" value="'+topUpAmount+'" required />' +
                                                                        '</div>' +
                                                                    '</div>',
                                                                    focusConfirm: false,
                                                                    onBeforeOpen: () => {
                                                                        $("#deposit_slip").change(function () {
                                                                            var reader = new FileReader();
                                                                            reader.readAsDataURL(this.files[0]);
                                                                        });
                                                                    },
                                                                    preConfirm: () => {
                                                                        /*return [
                                                                            document.getElementById('swal-input1').value,
                                                                            document.getElementById('swal-input2').value
                                                                        ]
                                                                        */
                                                                        var gifted_bank = $('#gifted_bank').val();
                                                                        var bank_name = $('#bank_name').val();
                                                                        var account_name = $('#account_name').val();
                                                                        var account_number = $('#account_number').val();
                                                                        var amount = $('#amount').val();
                                                                        var deposit_slip = $('#deposit_slip')[0].files[0];

                                                                        var formData = new FormData();
                                                                        formData.append("gifted_bank", gifted_bank);
                                                                        formData.append("bank_name", bank_name);
                                                                        formData.append("account_name", account_name);
                                                                        formData.append("account_number", account_number);
                                                                        formData.append("amount", amount);
                                                                        formData.append("deposit_slip", deposit_slip);
                                                                        formData.append("email", email);
                                                                        formData.append("page", '/redeem/ggc-plus');

                                                                        //console.log(deposit_slip);

                                                                        let countError = 0;

                                                                        if(gifted_bank == ''){
                                                                            countError += 1;
                                                                            $('#gifted_bank').addClass('error');
                                                                        }else{
                                                                            $('#gifted_bank').removeClass('error');
                                                                        }

                                                                        if(bank_name == ''){
                                                                            countError += 1;
                                                                            $('#bank_name').addClass('error');
                                                                        }else{
                                                                            $('#bank_name').removeClass('error');
                                                                        }

                                                                        if(account_name == ''){
                                                                            countError += 1;
                                                                            $('#account_name').addClass('error');
                                                                        }else{
                                                                            $('#account_name').removeClass('error');
                                                                        }

                                                                        if(account_number == ''){
                                                                            countError += 1;
                                                                            $('#account_number').addClass('error');
                                                                        }else{
                                                                            $('#account_number').removeClass('error');
                                                                        }

                                                                        if(deposit_slip == '' || deposit_slip == undefined){
                                                                            countError += 1;
                                                                            $('#deposit_slip').addClass('error');
                                                                        }else{
                                                                            $('#deposit_slip').removeClass('error');
                                                                        }

                                                                        //alert(deposit_slip);
                                                                        if(countError == 0){
                                                                            Swal.fire({
                                                                              icon: 'warning',
                                                                              title: 'Please wait!',
                                                                              html: 'Your topup is processing...',
                                                                              showConfirmButton: false,
                                                                            });

                                                                            $.ajax({
                                                                                type: "POST",
                                                                                url: "/api/wallet/topup",
                                                                                data: formData,
                                                                                processData: false,
                                                                                contentType: false,
                                                                                cache: false,
                                                                            })
                                                                            .then(response => {
                                                                                console.log(response);

                                                                                const result = JSON.parse(response);

                                                                                if(result.response.class == "success"){    
                                                                                    Swal.fire({
                                                                                        icon: result.response.class,
                                                                                        title: result.response.message,
                                                                                        confirmButtonColor: '#DE3C4C',
                                                                                        showLoaderOnConfirm: true,
                                                                                        background: '#fff',
                                                                                        backdrop: 'rgb(198, 227, 222)',
                                                                                        html: '',
                                                                                      confirmButtonColor: '#DE3C4C',
                                                                                      confirmButtonText: 'Close'
                                                                                    }).then((result) => {
                                                                                        if (result.isConfirmed) {
                                                                                            location.reload();
                                                                                        }
                                                                                    });
                                                                                }else{
                                                                                    Swal.fire({
                                                                                        icon: result.response.class,
                                                                                        title: result.response.message,
                                                                                        html:
                                                                                        'Please try again later.',
                                                                                        showConfirmButton: false,
                                                                                    });
                                                                                }
                                                                               
                                                                            })
                                                                            .catch(error => {
                                                                                Swal.showValidationMessage(
                                                                                  `Request failed! Please contact support.`
                                                                                )
                                                                            });

                                                                        }else{
                                                                            Swal.showValidationMessage(
                                                                              `Please complete the required fields.`
                                                                            );
                                                                        }

                                                                    }
                                                                })

                                                            }
                                                        }
                                                    })
                                                });
                                            },
                                            inputValidator: function(result) {
                                                return new Promise(function(resolve, reject) {
                                                  if (result) {
                                                    resolve();
                                                  } else {
                                                    Swal.showValidationMessage(
                                                      `You need to select amount!`
                                                    );
                                                    $('.swal2-radio label input[type=radio]').prop("disabled", false);
                                                    $('.swal2-actions button').prop("disabled", false);
                                                  }
                                                });
                                            }
                                        }).then(function(result) {
                                            console.log(result);
                                            if (result.isConfirmed) {

                                                /*
                                                Swal.fire({
                                                  icon: 'warning',
                                                  title: 'Please wait!',
                                                  html: 'Loading available payment options...',
                                                  showConfirmButton: false,
                                                });
                                                */


                                                Swal.fire({
                                                    title: 'Topup via Bank Transfer',
                                                    confirmButtonColor: '#DE3C4C',
                                                    showLoaderOnConfirm: true,
                                                    showCancelButton: true,
                                                    background: '#fff',
                                                    backdrop: 'rgb(198, 227, 222)',
                                                    html:
                                                    '<p>This is a form to submit your deposit slip for topup payment.</p>' +
                                                    '<div class="form-row">' +
                                                        '<div class="form-group col-md-12">' +
                                                            '<label for="">Please choose the bank account you will be depositing to: </label>' +
                                                            '<select name="gifted_bank" id="gifted_bank" class="form-control" required>' +
                                                                '<option value="">Select Gifted Bank Account</option>' +
                                                                '<option value="BDO Account : 006938009120">BDO account : 006938009120</option>' +
                                                                '<option value="BPI Account: 3911-0043-12">BPI Account: 3911-0043-12</option>' +
                                                                '<option value="Unionbank Account: 00-192-000113-2">Unionbank Account: 00-192-000113-2</option>' +
                                                            '</select>' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<p>Our Bank Account Name is "E-link Business Innovation Corp"<br />After you deposit, please provide details about your deposit slip so we can verify your topup:</p>' +
                                                    '<div class="form-row">' +
                                                        '<div class="form-group col-md-6">' +
                                                            '<label for="">Your Bank Name</label>' +
                                                            '<input type="text" class="form-control" id="bank_name" name="bank_name" placeholder="Bank Name" required/>' +
                                                        '</div>' +
                                                        '<div class="form-group col-md-6">' +
                                                            '<label for="">Account Name</label>' +
                                                            '<input type="text" class="form-control" id="account_name" name="account_name" placeholder="Account Name" required />' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="form-row">' +
                                                        '<div class="form-group col-md-6">' +
                                                            '<label for="">Your Account Number</label>' +
                                                            '<input type="text" class="form-control" id="account_number" name="account_number" placeholder="Account Number" required />' +
                                                        '</div>' +
                                                        '<div class="form-group col-md-6">' +
                                                            '<label for="">Deposit Slip (2MB)</label>' +
                                                            '<input type="file" class="form-control" id="deposit_slip" name="deposit_slip" accept="image/*" required  />' +
                                                        '</div>' +
                                                        '<div class="form-group col-md-6" style="display: none;">' +
                                                            '<label for="">Amount</label>' +
                                                            '<input type="text" class="form-control" id="amount" name="amount" placeholder="Amount" value="'+result.value+'" required />' +
                                                        '</div>' +
                                                    '</div>',
                                                    focusConfirm: false,
                                                    onBeforeOpen: () => {
                                                        $("#deposit_slip").change(function () {
                                                            var reader = new FileReader();
                                                            reader.readAsDataURL(this.files[0]);
                                                        });
                                                    },
                                                    preConfirm: () => {
                                                        /*return [
                                                            document.getElementById('swal-input1').value,
                                                            document.getElementById('swal-input2').value
                                                        ]
                                                        */
                                                        var gifted_bank = $('#gifted_bank').val();
                                                        var bank_name = $('#bank_name').val();
                                                        var account_name = $('#account_name').val();
                                                        var account_number = $('#account_number').val();
                                                        var amount = $('#amount').val();
                                                        var deposit_slip = $('#deposit_slip')[0].files[0];

                                                        var formData = new FormData();
                                                        formData.append("gifted_bank", gifted_bank);
                                                        formData.append("bank_name", bank_name);
                                                        formData.append("account_name", account_name);
                                                        formData.append("account_number", account_number);
                                                        formData.append("amount", amount);
                                                        formData.append("deposit_slip", deposit_slip);
                                                        formData.append("email", email);
                                                        formData.append("page", '/redeem/ggc-plus');

                                                        //console.log(deposit_slip);

                                                        let countError = 0;

                                                        if(gifted_bank == ''){
                                                            countError += 1;
                                                            $('#gifted_bank').addClass('error');
                                                        }else{
                                                            $('#gifted_bank').removeClass('error');
                                                        }

                                                        if(bank_name == ''){
                                                            countError += 1;
                                                            $('#bank_name').addClass('error');
                                                        }else{
                                                            $('#bank_name').removeClass('error');
                                                        }

                                                        if(account_name == ''){
                                                            countError += 1;
                                                            $('#account_name').addClass('error');
                                                        }else{
                                                            $('#account_name').removeClass('error');
                                                        }

                                                        if(account_number == ''){
                                                            countError += 1;
                                                            $('#account_number').addClass('error');
                                                        }else{
                                                            $('#account_number').removeClass('error');
                                                        }

                                                        if(deposit_slip == '' || deposit_slip == undefined){
                                                            countError += 1;
                                                            $('#deposit_slip').addClass('error');
                                                        }else{
                                                            $('#deposit_slip').removeClass('error');
                                                        }

                                                        //alert(deposit_slip);
                                                        if(countError == 0){
                                                            Swal.fire({
                                                              icon: 'warning',
                                                              title: 'Please wait!',
                                                              html: 'Your topup is processing...',
                                                              showConfirmButton: false,
                                                            });

                                                            $.ajax({
                                                                type: "POST",
                                                                url: "/api/wallet/topup",
                                                                data: formData,
                                                                processData: false,
                                                                contentType: false,
                                                                cache: false,
                                                            })
                                                            .then(response => {
                                                                console.log(response);

                                                                const result = JSON.parse(response);

                                                                if(result.response.class == "success"){    
                                                                    Swal.fire({
                                                                        icon: result.response.class,
                                                                        title: result.response.message,
                                                                        confirmButtonColor: '#DE3C4C',
                                                                        showLoaderOnConfirm: true,
                                                                        background: '#fff',
                                                                        backdrop: 'rgb(198, 227, 222)',
                                                                        html: '',
                                                                        confirmButtonColor: '#DE3C4C',
                                                                        confirmButtonText: 'Close'
                                                                    }).then((result) => {
                                                                        if (result.isConfirmed) {
                                                                            location.reload();
                                                                        }
                                                                    });
                                                                }else{
                                                                    Swal.fire({
                                                                        icon: result.response.class,
                                                                        title: result.response.message,
                                                                        html:
                                                                        'Please try again later.',
                                                                        showConfirmButton: false,
                                                                    });
                                                                }
                                                               
                                                            })
                                                            .catch(error => {
                                                                Swal.showValidationMessage(
                                                                  `Request failed! Please contact support.`
                                                                )
                                                            });

                                                        }else{
                                                            Swal.showValidationMessage(
                                                              `Please complete the required fields.`
                                                            );
                                                        }

                                                    }
                                                })

                                                /*
                                                // Paypal Transaction
                                                Swal.fire({
                                                  icon: 'warning',
                                                  title: 'Please wait!',
                                                  html: 'Your topup is processing...',
                                                  showConfirmButton: false,
                                                })

                                                $.ajax({
                                                    type: "POST",
                                                    url: "/api/topup",
                                                    data: {'amount': result.value, 'email': email, 'page': '/redeem/ggc-plus'},
                                                    cache: false,
                                                })
                                                .then(response => {
                                                    console.log(response);

                                                    const result = JSON.parse(response);

                                                    if(result.response.class == "success"){    
                                                        Swal.fire({
                                                          icon: result.response.class,
                                                          title: result.response.message,
                                                          html: '',
                                                          showConfirmButton: false,
                                                        })

                                                        setTimeout(function () {
                                                            window.location.href = result.response.data;
                                                        }, 1500)
                                                    }else{
                                                        Swal.fire({
                                                          icon: result.response.class,
                                                          title: result.response.message,
                                                          html:
                                                            'Please try again later.',
                                                          showConfirmButton: false,
                                                        })
                                                    }
                                                   
                                                })
                                                .catch(error => {
                                                    Swal.showValidationMessage(
                                                      `Request failed! Please contact support.`
                                                    )
                                                });
                                                */
                                            }
                                        });

                                    }else{

                                        Swal.showValidationMessage(
                                              `OTP is invalid. Please check your email.`
                                            );
                                        $('#swal-input2-otp').focus();

                                    }
                                })
                                .catch(error => {
                                    Swal.showValidationMessage(
                                      `Request failed! Please contact support.`
                                    )
                                })
               
                            }else{
                                Swal.showValidationMessage(
                                      `OTP is required. Please check your email.`
                                    );
                                $('#swal-input2-otp').focus();
                            }

                        },
                        allowOutsideClick: () => !Swal.isLoading()
                    });

            },
            topUpCustomAmount:function(email){
                alert(email);

            }
        }
    }

    let timerOn = true;

    function timer(remaining) {
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;

        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;
        $("#timer").html(m + ':' + s);
        remaining -= 1;

        if(remaining >= 0 && timerOn) {
        setTimeout(function() {
            timer(remaining);
        }, 1000);
        return;
        }

        if(!timerOn) {
        // Do validate stuff here
        return;
        }

        // Do timeout stuff here
        //alert('Timeout for otp');
        $("#resendOTP").prop('disabled', false);
        $("#timer").html("");
    }
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    
    //$( "body" ).delegate( "#resendOTP", "click", function(event) {
    $('#resendOTP').on('click', function(e){

        console.log('arjohn testing');
        var $link = $(e.target);
        e.preventDefault();
        if(!$link.data('lockedAt') || +new Date() - $link.data('lockedAt') > 300) {
            $(this).prop('disabled', true);
            var email = $(this).data( "email");
            var source = $(this).data( "source");
            //alert(email);
            timer(120);

            $('#btn-text').text('Resend');
            return $.ajax({
                type: "POST",
                url: "/api/resend_otp1",
                data: { 
                    'email': email, 
                    'source': source, 
                    '_token': $('meta[name="csrf_token"]').attr('content') 
                },
                cache: false
            })
            .then(response => {
                console.log(response);
                //return response
                $('#otp-message').html("<p style='margin: 5px 0 0;' class='text-success'>Please check your email for OTP</p>");
                setTimeout(function () {
                       $('#otp-message').slideUp().html("");
                    }, 5000);
                $('#swal-input2-otp').focus();
            })
            .catch(error => {
                Swal.showValidationMessage(
                  `Request OTP failed! Please contact support.`
                )
            });
        }
        $link.data('lockedAt', +new Date());

    });

</script>